
import * as React from 'react';
import { getFirmShortName } from '@utils/profileUtils';
import { Client } from '@types';
import { PresentationType, Profile } from '@constants';

type PresentationContextValue = {
  client: Client,
  clientViewing: boolean,
  presentationType: PresentationType,
  presentationId: number,
  profile: Profile | null
}

const PresentationContext = React.createContext<PresentationContextValue | undefined>(undefined);

export const PresentationProvider: React.FC<PresentationContextValue> = (props: PresentationContextValue) => {
    const presentationState = { ...props};
    const { client } = props;
    const { firm } = client;

    client.firmShortName = getFirmShortName(firm);
    
    return (
        <PresentationContext.Provider value={presentationState} {...props} />
    );
};

export const usePresentation = () => {
  return getPresentationState();
};

export const useClient = () => {
  const presentationState = getPresentationState();

  return presentationState.client;
};

function getPresentationState() {
  const presentationState = React.useContext(PresentationContext);

  if (presentationState === undefined) {
    throw new Error('useClient must be used within a PresentationProvider');
  }

  return presentationState;
}
